module.exports = __webpack_public_path__ + "images/banners/happy-team.c5884503ef781d485ff1.svg";